<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Agent Assist" class="d-icon d-icon--agent-assist" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M.955 2.458c0-.835.678-1.512 1.513-1.512h3.494a.5.5 0 0 1 0 1H2.468a.512.512 0 0 0-.513.512v7.718l1.52-.917a.5.5 0 0 1 .258-.072h5.824c.283 0 .512-.23.512-.512V5.874a.5.5 0 0 1 1 0v2.8c0 .836-.677 1.514-1.512 1.514H3.872l-2.16 1.301a.5.5 0 0 1-.757-.429V2.458Zm5.01 1.012c.064 0 .12.043.14.104A3.085 3.085 0 0 0 8.108 5.59c.063.02.107.078.107.145a.153.153 0 0 1-.107.145 3.085 3.085 0 0 0-1.984 1.954.17.17 0 0 1-.16.117.17.17 0 0 1-.16-.117 3.086 3.086 0 0 0-1.958-1.946.162.162 0 0 1-.113-.153c0-.07.047-.131.113-.153a3.085 3.085 0 0 0 1.98-2.01.147.147 0 0 1 .138-.103Zm3.299-2.278c.042 0 .08.03.092.07a2.06 2.06 0 0 0 1.328 1.352.103.103 0 0 1 .073.098c0 .045-.03.084-.073.097-.618.2-1.108.689-1.314 1.31a.113.113 0 0 1-.106.078.113.113 0 0 1-.106-.079A2.057 2.057 0 0 0 7.86 2.814a.109.109 0 0 1-.075-.103c0-.047.031-.088.075-.102a2.057 2.057 0 0 0 1.311-1.346.098.098 0 0 1 .093-.07Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconAgentAssist',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
